export default {
    namespaced: true,
    state: {
        errors: {
            sendMessage: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        }
    },
    actions: {
        async sendMessage({ commit }, data) {
            commit('SET_ERRORS', {
                key: 'sendMessage',
                val: ''
            })

            const url = '/retailer/messages/brand/' + data.brandID

            try {
                const resp = await this.$axios.post(url, data)
            } catch (e) {
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'sendMessage',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'sendMessage',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        resetErrors({ commit }) {
            commit('SET_ERRORS', {
                key: 'sendMessage',
                val: ''
            })
        }
    }
}
